module.exports = __webpack_public_path__ + "static/media/docs.6cec9994.svg";